import { render, staticRenderFns } from "./legalPerson.vue?vue&type=template&id=58bd2368&scoped=true&"
import script from "./legalPerson.vue?vue&type=script&lang=js&"
export * from "./legalPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd2368",
  null
  
)

export default component.exports